import React, { useState } from 'react';
import { Hero } from './components/Hero';
import { WhatIOffer } from './components/WhatIOffer';
import { QuoteForm } from './components/QuoteForm';
import { WhySimon } from './components/WhySimon';
import { HowItWorks } from './components/HowItWorks';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  const [lang, setLang] = useState<'en' | 'es'>('en');
  return <div className="min-h-screen bg-background text-white font-sans selection:bg-primary selection:text-white" data-id="element-0">
      <Hero lang={lang} setLang={setLang} data-id="element-1" />
      <WhatIOffer lang={lang} data-id="element-2" />
      <QuoteForm lang={lang} data-id="element-3" />
      <WhySimon lang={lang} data-id="element-4" />
      <HowItWorks lang={lang} data-id="element-5" />
      <FinalCTA lang={lang} data-id="element-6" />
      <Footer lang={lang} data-id="element-7" />
    </div>;
}